<template>
  <div>
    <b-container fluid class="content page-top">
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <el-row :gutter="10">
                <el-col :span="3">
                  <div class="label-class">{{ $t('Store') }}</div>
                  <select class="form-control" v-model="cur_LocationID">
                    <option value="">{{ $t("Select Store") }}</option>
                    <option
                      v-for="(dt, idx) in storelist"
                      :key="idx"
                      :value="dt.storeID"
                    >
                      {{ dt.storeID }} - {{ dt.storeName }}
                    </option>
                  </select>
                </el-col>
                <el-col :span="3">
                  <div class="label-class">{{ $t('Order #') }}</div>
                  <b-input :placeholder="$t('Transaction#')" v-model="cur_TransactionNo"></b-input>
                </el-col>
                <el-col :span="3">
                  <div class="label-class">{{ $t('Start Date') }}</div>
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker
                      key="f1"
                      v-model="cur_FromDate"
                      @on-change="changeFrom"
                      slot-scope="{ focus, blur }"
                      placeholder='From Date'
                      @on-open="focus"
                      @on-close="blur"
                      :config="picker_config_s"
                      class="form-control datepicker"
                    >
                    </flat-picker>
                  </base-input>
                </el-col>
                <el-col :span="3">
                  <div class="label-class">{{ $t('End Date') }}</div>
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker
                      key="f2"
                      v-model="cur_ToCreateDate"
                      @on-change="changeTo"
                      slot-scope="{ focus, blur }"
                      placeholder='To Date'
                      @on-open="focus"
                      @on-close="blur"
                      :config="picker_config_e"
                      class="form-control datepicker"
                    >
                    </flat-picker>
                  </base-input>
                </el-col>
                <el-col :span="3">
                  <div class="label-class" @click="onHelpClick">
                    {{ $t('Code') }}<span class='help-btn'>&#63;</span>
                  </div>
                  <select class="form-control" v-model="cur_POSCode">
                    <option value="">{{ $t("Select Code") }}</option>
                    <option
                      v-for="(code, idx) in POSCodelist"
                      :key="idx"
                      :value="code.Code"
                    >
                      {{ code.Code }} - <span v-if="lang=='en'">{{ code.CodeName1 }}</span><span v-else>{{ code.CodeName2 }}</span>
                    </option>
                  </select>
                </el-col>
                <el-col :span="3">
                  <div class="label-class">{{ $t('Staff') }}</div>
                  <select class="form-control" v-model="cur_EmpoloyIDn">
                    <option value=""></option>
                    <option
                      v-for="(emp, idx) in employeelist"
                      :key="idx"
                      :value="emp.UserIDn"
                    >
                      {{ emp.UserIDn }} - {{ emp.Cashier }}
                    </option>
                  </select>
                </el-col>
                <el-col :span="3">
                  <div class="label-class">{{ $t('Station') }}</div>
                  <select class="form-control" v-model="cur_StationNo">
                    <option value="">Station</option>
                    <option
                      v-for="(st, idx) in stationlist"
                      :key="idx"
                      :value="st.StationNo"
                    >
                      {{ st.StationNo }}
                    </option>
                  </select>
                </el-col>
                <el-col :span="3" class="text-center">
                  <el-button
                    type="primary"
                    class="mt-4"
                    icon="el-icon-search"
                    size="small"
                    @click="get_data_list(0)"
                    >{{ $t("Search") }}</el-button
                  >
                </el-col>
              </el-row>
            </b-form>
          </b-card>
          <b-card>
            <div class="p-0" v-if="datalist">
              <el-row :gutter="20">
                <el-col :span="24"><h2>{{ $t('POS Monitoring Log') }}</h2></el-col>
              </el-row>
              <el-table stripe class="table-responsive table" header-row-class-name="thead-light" :data="datalist" @row-click="row_clicked_event">
                <el-table-column :label="$t('Date Time')" width="200">
                  <template #default="scope">
                    <div>{{ scope.row.Tm }}</div>
                    <div class="store-name">{{ scope.row.StoreName }}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Code')" prop="RiskLevel" width="160">
                  <template #default="scope">
                    <div class="risklevel">
                      <span v-if="scope.row.RiskLevel == '1'" class="highrisk">{{ scope.row.Code }}</span>
                      <span v-if="scope.row.RiskLevel == '2'" class="mediumrisk">{{ scope.row.Code }}</span>
                      <span v-if="scope.row.RiskLevel == '3'" class="lowrisk">{{ scope.row.Code }}</span>
                    </div>
                    <div class="risk-name"><span v-if="lang=='en'">{{ scope.row.CodeName1 }}</span><span v-else>{{ scope.row.CodeName2 }}</span></div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Employee')" prop="Cashier" width="160"></el-table-column>
                <el-table-column :label="$t('OrderNo')" prop="TransactionNo" width="220"></el-table-column>
                <el-table-column :label="$t('Remarks')" prop="Notes">
                  <template #default="scope">
                    <span v-if="lang=='en'">{{ scope.row.Notes1 }}</span><span v-else>{{ scope.row.Notes2 }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Station')" prop="StationNo" width="100"></el-table-column>
              </el-table>
              <nav aria-label="Page navigation">
                  <ul class="pagination justify-content-center">
                    <!-- Previous Button -->
                    <li class="page-item" :class="{'disabled': page_number <= 1}">
                      <a class="page-link" href="#" aria-label="Previous" @click.prevent="changePage(page_number - 1)">
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>

                    <!-- Loop through 5 continuous pages -->
                    <li
                      class="page-item"
                      v-for="page in pageNumbers"
                      :key="page"
                      :class="{'active': page === page_number}"
                    >
                      <a class="page-link" href="#" @click.prevent="changePage(page)">
                        {{ page }}
                      </a>
                    </li>

                    <!-- Next Button -->
                    <li class="page-item" :class="{'disabled': page_number >= totalPages}">
                      <a class="page-link" href="#" aria-label="Next" @click.prevent="changePage(page_number + 1)">
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            <div class="p-3" v-else>
              {{ $t("No Records") }}
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col> </b-col>
      </b-row>
    </b-container>
    <vue-element-loading
      :active="showloading"
      spinner="bar-fade-scale"
      color="#FF6700"
      duration="2.0"
      background-color="rgba(255, 255, 255, .5)"
      size="100"
    />
    <b-modal v-model="detailDialog" :title="diallogTitle" size="xl" scrollable>
      <b-row>
        <b-col :cols="6" v-for="(dt, idx) in showData" :key="idx" class="dialog-item">
          <div class="dialog-label">{{ dt.label }}</div>
          <div class="dialog-data prewrap">{{ dt.data }}</div>
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="dialog-footer">
          <el-button @click="detailDialog = false">Cancel</el-button>
        </div>
      </template>
    </b-modal>
    <b-modal v-model="codeDialog" :title="$t('Code')"  size="xl" ok-only>
      <b-table :items="POSCodelist" :fields="codeFields" striped hover>
        <template #cell(RiskLevel)="data">
          <div class="risklevel">
            <span v-if="data.item.RiskLevel == '1'" class="highrisk">{{ $t("High") }}</span>
            <span v-if="data.item.RiskLevel == '2'" class="mediumrisk">{{ $t("Medium") }}</span>
            <span v-if="data.item.RiskLevel == '3'" class="lowrisk">{{ $t("Low") }}</span>
          </div>
        </template>
        <template #cell(Remarks)="data">
          <div class="remarks-cell">{{ data.item.Remarks }}</div>
        </template>
      </b-table>
      <template #modal-footer>
        <div class="dialog-footer">
          <el-button @click="codeDialog = false">Cancel</el-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Button,
  Pagination,
  Collapse,
  CollapseItem,
  Dialog,
  Row,
  Col,
} from "element-ui";
import SearchAutocomplete from "../Components/SearchAutocomplete";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { getStore, setStore } from "../../util/helper";
import VueElementLoading from "vue-element-loading";

const axios = require("axios");

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Row.name]: Row,
    [Col.name]: Col,
    [Dialog.name]: Dialog,
    [Pagination.name]: Pagination,
    VueElementLoading,
    flatPicker,
    // SearchAutocomplete,
  },
  data() {
    return {
      cur_LocationID: "",
      cur_TransactionNo: "",
      cur_FromDate: "",
      cur_ToCreateDate: "",
      cur_POSCode: "",
      cur_EmpoloyIDn: "",
      cur_StationNo: "",
      showloading: false,
      todaystr: "",

      hasExport: false,
      total_count: 0,  // total records count
      page_number: 1,  // current page number, starts from 1
      per_page: 50,    // records per page

      storelist: [],
      POSCodelist: [],
      employeelist: [],
      stationlist: [],

      datalist: null,

      lang: 'en',

      picker_config_s: {
        allowInput: true,
        dateFormat: 'Y-m-d',
        altFormat: 'Y-m-d',
        maxDate: 'today', // New Date();  YYYY-MM-DD HH:MM
      },

      picker_config_e: {
        allowInput: true,
        dateFormat: 'Y-m-d',
        altFormat: 'Y-m-d',
        maxDate: 'today', // New Date();  YYYY-MM-DD HH:MM
      },

      detailDialog: false,
      diallogTitle: "",
      showData: null,

      codeDialog: false,
      codeFields: [
        { key: 'Code', label: this.$t('Code'), thStyle: { width: '70px' } },
        { key: 'CodeName1', label: this.$t('Name')+'1' },
        { key: 'CodeName2', label: this.$t('Name')+'2' },
        { key: 'RiskLevel', label: this.$t('Risk Level') },
        { key: 'Remarks', label: this.$t('Remarks') }
      ],

      token: "",
      user_id: 0,
    };
  },
  computed: {
    apiBaseUrl: function () {
      return axios.defaults.baseURL + "/Api";
    },
    totalPages() {
      return Math.ceil(this.total_count / this.per_page);
    },
    pageNumbers() {
      let startPage = Math.max(1, this.page_number - 2);
      let endPage = Math.min(this.totalPages, startPage + 4);
      if (endPage - startPage < 4) {
        startPage = Math.max(1, endPage - 4); // Move start page left if there aren't enough pages
      }

      return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    },
  },
  methods: {
    row_clicked_event(row, event, column) {
      // console.log("Pos_log_report.vue row_clicked_event", row, event, column);
      if (this.detailDialog) {
        this.detailDialog = false;
      } else {
        this.showData = this.getShowData(row);
        this.diallogTitle = (this.lang == 'en')?row.CodeName1:row.CodeName2;
        this.detailDialog = true;
      }
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.page_number = page;
        this.get_data_list(0);
      }
    },
    onHelpClick() {
      if (this.codeDialog) {
        this.codeDialog = false;
      } else {
        this.codeDialog = true;
      }
    },
    getShowData(log) {
      let data = [];
      if (log.Code == "CP") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: 'Name1', data: reason.from.Name1});
        data.push({label: 'Name1', data: reason.to.Name1});

        data.push({label: 'Name2', data: reason.from.Name2});
        data.push({label: 'Name2', data: reason.to.Name2});

        data.push({label: 'Price', data: parseFloat(reason.from.Price).toFixed(2)});
        data.push({label: 'Price', data: parseFloat(reason.to.Price).toFixed(2)});

        data.push({label: 'PriceGroup', data: reason.PriceGroup});
        data.push({label: 'Cashier', data: log.Cashier});
      } else if (log.Code == "PO") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});

        data.push({label: 'Name1', data: reason.Name1});
        data.push({label: 'Name2', data: reason.Name2});

        data.push({label: 'Price', data: parseFloat(reason.from.Price).toFixed(2)});
        data.push({label: 'Qty', data: reason.Qty});

        data.push({label: 'Org SubTotal', data: parseFloat(reason.from.ItemSubTotal).toFixed(2)});
        data.push({label: 'New SubTotal', data: parseFloat(reason.to.ItemSubTotal).toFixed(2)});
      } else if (log.Code == "DI") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});

        data.push({label: 'Name1', data: reason.Name1});
        data.push({label: 'Name2', data: reason.Name2});

        data.push({label: 'Qty', data: reason.Qty});
        data.push({label: 'SubTotal', data: parseFloat(reason.from.ItemSubTotal).toFixed(2)});
      } else if (log.Code == "ID") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});

        data.push({label: 'Name1', data: reason.Name1});
        data.push({label: 'Name2', data: reason.Name2});

        data.push({label: 'Qty', data: reason.Qty});
        data.push({label: '', data: ''});

        data.push({label: 'Org Name1', data: reason.from.ItemDiscountName1});
        data.push({label: 'New Name1', data: reason.to.ItemDiscountName1});

        data.push({label: 'Org Name2', data: reason.from.ItemDiscountName2});
        data.push({label: 'New Name2', data: reason.to.ItemDiscountName2});

        data.push({label: 'Org Type', data: reason.from.ItemDiscountType});
        data.push({label: 'New Type', data: reason.to.ItemDiscountType});

        data.push({label: 'Org Value', data: reason.from.ItemDiscountValue});
        data.push({label: 'New Value', data: reason.to.ItemDiscountValue});

        data.push({label: 'Org SubTotal', data: parseFloat(reason.from.ItemSubTotal).toFixed(2)});
        data.push({label: 'New SubTotal', data: parseFloat(reason.to.ItemSubTotal).toFixed(2)});
      } else if (log.Code == "DP") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});

        data.push({label: 'Org Name1', data: reason.from.Name1});
        data.push({label: 'New Name1', data: reason.to.Name1});

        data.push({label: 'Org Name2', data: reason.from.Name2});
        data.push({label: 'New Name2', data: reason.to.Name2});

        data.push({label: 'Org Type', data: reason.from.Type});
        data.push({label: 'New Type', data: reason.to.Type});

        data.push({label: 'Org Value', data: reason.from.Value});
        data.push({label: 'New Value', data: reason.to.Value});

        data.push({label: 'Org SubTotal', data: parseFloat(reason.from.SubTotalAmount).toFixed(2)});
        data.push({label: 'New SubTotal', data: parseFloat(reason.to.SubTotalAmount).toFixed(2)});

        data.push({label: 'Org TAX', data: parseFloat(reason.from.AllTaxTotalAmount).toFixed(2)});
        data.push({label: 'New TAX', data: parseFloat(reason.to.AllTaxTotalAmount).toFixed(2)});

        data.push({label: 'Org Total', data: parseFloat(reason.from.TotalAmount).toFixed(2)});
        data.push({label: 'New Total', data: parseFloat(reason.to.TotalAmount).toFixed(2)});
      } else if (log.Code == "VO") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});

        data.push({label: 'Item Count', data: parseFloat(reason.TotalItemCount).toFixed(2)});
        data.push({label: 'SubTotal', data: parseFloat(reason.SubTotalAmount).toFixed(2)});

        data.push({label: 'TAX', data: parseFloat(reason.AllTaxTotalAmount).toFixed(2)});
        data.push({label: 'Total', data: parseFloat(reason.TotalAmount).toFixed(2)});
      } else if (log.Code == "VE") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});
      } else if (log.Code == "JB") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "A", data: log.CodeName1});
        } else {
          data.push({label: " ", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});

        data.push({label: 'Item Count', data: reason.TotalItemCount});
        data.push({label: 'Total', data: parseFloat(reason.TotalAmount).toFixed(2)});

        data.push({label: 'Orig Orders', data: reason.Transactions.join("\n")});
        data.push({label: 'To Order', data: reason.TransactionNo});
      } else if (log.Code == "SB") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});

        data.push({label: 'Item Count', data: reason.TotalItemCount});
        data.push({label: 'Total', data: parseFloat(reason.TotalAmount).toFixed(2)});

        data.push({label: 'Orig Order', data: reason.TransactionNo});
        data.push({label: 'To Orders', data: reason.Transactions.join("\n")});
      } else if (log.Code == "RC") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});

        data.push({label: 'Item Count', data: reason.TotalItemCount});
        data.push({label: 'Total', data: parseFloat(reason.TotalAmount).toFixed(2)});
      } else if (log.Code == "CT") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});

        data.push({label: 'Item Count', data: reason.TotalItemCount});
        data.push({label: 'Total', data: parseFloat(reason.TotalAmount).toFixed(2)});

        data.push({label: 'From Table', data: reason.FromTable.Name});
        data.push({label: 'To Table', data: reason.ToTable.Name});
      } else if (log.Code == "CN") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});

        data.push({label: 'Item Count', data: reason.TotalItemCount});
        data.push({label: 'Total', data: parseFloat(reason.TotalAmount).toFixed(2)});

        data.push({label: 'From Adult', data: reason.from.AdultCount});
        data.push({label: 'To Adult', data: reason.to.AdultCount});

        data.push({label: 'From Minor', data: reason.from.ChildCount});
        data.push({label: 'To Minor', data: reason.to.ChildCount});

        data.push({label: 'From Total', data: reason.from.Count});
        data.push({label: 'To Total', data: reason.to.Count});
      } else if (log.Code == "UL") {
        data.push({label: this.$t('Code'), data: log.Code});
        if (this.lang == "en") {
          data.push({label: "", data: log.CodeName1});
        } else {
          data.push({label: "", data: log.CodeName2});
        }
        let reason = JSON.parse(log.Reasons);

        data.push({label: 'Order #', data: reason.TransactionNo});
        data.push({label: this.$t('Date Time'), data: log.Tm});

        data.push({label: this.$t('Store Name'), data: log.StoreName});
        data.push({label: 'Cashier', data: log.Cashier});

        data.push({label: 'StationNo', data: log.StationNo});
        data.push({label: 'ComputerName', data: log.ComputerName});
      }
      // console.log("showData ==>> ", data);
      return data;
    },
    changeFrom() {
      console.log("Pos_log_report.vue changeFrom");
    },
    changeTo() {
      console.log("Pos_log_report.vue changeTo");
    },
    async get_data_list(init) {
      this.showloading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("init", init);
      bodyFormData.append("page_number", this.page_number);
      bodyFormData.append("per_page", this.per_page);

      if (this.cur_LocationID) {
        bodyFormData.append("StoreID", this.cur_LocationID);
      }
      if (this.cur_TransactionNo) {
        bodyFormData.append("TransactionNo", this.cur_TransactionNo);
      }
      if (this.cur_FromDate) {
        bodyFormData.append("FromCreateDate", this.cur_FromDate);
      }
      if (this.cur_ToCreateDate) {
        bodyFormData.append("ToCreateDate", this.cur_ToCreateDate);
      }
      if (this.cur_POSCode) {
        bodyFormData.append("Code", this.cur_POSCode);
      }
      if (this.cur_EmpoloyIDn) {
        bodyFormData.append("UserIDn", this.cur_EmpoloyIDn);
      }
      if (this.cur_StationNo) {
        bodyFormData.append("StationNo", this.cur_StationNo);
      }

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/POS/poslog",
        data: bodyFormData,
      })
        .then(function (response) {
          that.showloading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (init) {
                that.storelist = rt.data.storelist;
                that.POSCodelist = rt.data.POSCodelist;
                that.employeelist = rt.data.employeelist;
                that.stationlist = rt.data.stationlist;
              }
              that.datalist = rt.data.datalist;
              that.total_count = rt.data.datacount;
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          that.showloading = false;
          // console.log(error);
          that.$router.push("/login");
        });
    },
    formatFloatVal (v) {
      let val = parseFloat(v);
      if (val == 0) {
        return "";
      }
      if (Number.isInteger(v)) {
        return val.toFixed(0);
      }
      return val.toFixed(2);
    },
    init_data() {
      var today = new Date();
      this.todaystr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');

      if (this.$i18n.locale == "en"){
        this.lang = "en";
      } else {
        this.lang = "cn";
      }

      this.token = getStore("token");
      this.user_id = getStore("user_id");
      if (!this.token || !this.user_id) {
        this.$router.push("/login");
        return;
      }
      return this.get_data_list(1);
    },
  },
  watch: {
    '$i18n.locale'(locale) {
      if (locale == "en") {
        this.lang = "en";
      } else {
        this.lang = "cn";
      }
    }
  },
  mounted() {
    this.init_data();
    this.windowHeight = window.innerHeight;
  },
};
</script>
<style>
.risklevel {
  display: flex;                 /* Use Flexbox for centering */
  justify-content: center;       /* Center horizontally */
  align-items: center;
  height: 100%;
  width: 100%;
}
.highrisk {
  width: 80px;
  color: white;                 /* Text color */
  border: 2px solid #ff1600;    /* Border color */
  background-color: #e55f52;    /* Background color */
  border-radius: 5px;           /* Optional: rounded corners */
  text-align: center;           /* Center the text */
}
.mediumrisk {
  width: 80px;
  color: black;                 /* Text color */
  border: 2px solid #f9e71f;    /* Border color */
  background-color: #f8f863;    /* Background color */
  border-radius: 5px;           /* Optional: rounded corners */
  text-align: center;           /* Center the text */
}
.lowrisk {
  width: 80px;
  color: black;                 /* Text color */
  border: 2px solid #53b4f7;    /* Border color */
  background-color: #27e4f5;    /* Background color */
  border-radius: 5px;           /* Optional: rounded corners */
  text-align: center;           /* Center the text */
}
.label-class {
  padding-left: 1rem;
  position: relative;
  display: inline-block;
  font-weight: 600;
}
.help-btn {
  position: absolute;
  top: -6px;
  right: -18px;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 1px solid #dddddd;
  padding: 0;
  font-size: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.store-name {
  color: #a0a0a0;
  font-size: .7rem;
}
.risk-name {
  text-align: center;
}
.dialog-item {
  padding: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(0,0,0,0.06);
  background: linear-gradient(180deg, rgba(255,255,255,0.02), transparent);
}
.dialog-item:nth-child(2n) {
  background-color: #fbfbfb;
}
.dialog-label {
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
  min-height: 1.2em;          /* reserve height even if label is empty */
  visibility: visible;        /* keep box space — we'll hide only text when needed */
}
.dialog-label:empty {
  color: transparent;         /* keep space but hide text color */
}
.dialog-data {
  color: #444;
  white-space: normal;        /* allow wrapping */
  word-break: break-word;     /* break long words or long URLs */
  line-height: 1.4;
  max-height: 6em;            /* optional: limit height to n lines */
  overflow: hidden;           /* hide overflow when limiting height */
}
.dialog-data.preserve-newlines {
  white-space: pre-wrap;
}
.prewrap {
  white-space: pre-wrap;
  word-break: break-word;
}
@media (max-width: 767px) {
  .dialog-item {
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,0.08);
  }
}
.page-top {
  padding-top: 40px;
}
.page-top .card .table th {
  padding: 0rem;
}
.page-top .card .table td {
  padding: 0rem;
}
.page-top .picimg {
  padding-left: 3rem;
  max-height: 6rem;
}
.page-top .el-collapse-item__header {
  background-color: #f0f0f0;
  font-size: 1.2rem;
  padding-left: 1rem;
}
.page-top .el-collapse-item__content {
  padding-bottom: 0.5rem;
}
.page-top #mymodalclass .modal-title {
  font-size: 2rem !important;
}
.page-top #mymodalclass .modal-body {
  padding-top: 0;
  padding-bottom: 0;
}
.page-top .form-group {
  margin-bottom: 0.5rem;
}
.page-top .top_line {
  height: 1px;
  background: black;
}
.page-top .order_heads {
  background-color: #cccccc;
}
</style>
